<a href="{{ DocumentLink }}" target="_blank">
  <div class="card custom-card border">
    <div
      class="image-container align-items-center d-flex justify-content-center rounded-top-1 border border-bottom-0"
    >
      <img [src]="imgPath" class="card-img rounded-1" alt="{{ title }}" />

      <span *ngIf="isNew" class="badge new-badge py-1 px-2">
        <i class="bi bi-star-fill"></i>
        <svg
          width="12"
          class="mb-1"
          height="12"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3484 8.06625L8.12461 6.875L6.93711 3.64875C6.86679 3.45771 6.73956 3.29283 6.57259 3.17637C6.40561 3.0599 6.20694 2.99746 6.00336 2.99746C5.79979 2.99746 5.60111 3.0599 5.43414 3.17637C5.26716 3.29283 5.13993 3.45771 5.06961 3.64875L3.87461 6.875L0.648361 8.0625C0.457317 8.13282 0.29244 8.26005 0.175977 8.42702C0.0595144 8.594 -0.00292969 8.79267 -0.00292969 8.99625C-0.00292969 9.19983 0.0595144 9.3985 0.175977 9.56548C0.29244 9.73245 0.457317 9.85968 0.648361 9.93L3.87461 11.125L5.06211 14.3512C5.13243 14.5423 5.25966 14.7072 5.42664 14.8236C5.59361 14.9401 5.79229 15.0025 5.99586 15.0025C6.19944 15.0025 6.39811 14.9401 6.56509 14.8236C6.73206 14.7072 6.85929 14.5423 6.92961 14.3512L8.12461 11.125L11.3509 9.9375C11.5419 9.86718 11.7068 9.73995 11.8232 9.57298C11.9397 9.406 12.0022 9.20733 12.0022 9.00375C12.0022 8.80017 11.9397 8.6015 11.8232 8.43452C11.7068 8.26755 11.5419 8.14032 11.3509 8.07L11.3484 8.06625ZM7.56211 10.2638C7.49424 10.2888 7.43261 10.3282 7.38146 10.3793C7.33031 10.4305 7.29087 10.4921 7.26586 10.56L5.99961 13.9906L4.73586 10.5625C4.71089 10.4939 4.6712 10.4316 4.61959 10.38C4.56798 10.3284 4.5057 10.2887 4.43711 10.2638L1.00899 9L4.43711 7.73625C4.5057 7.71128 4.56798 7.67159 4.61959 7.61998C4.6712 7.56837 4.71089 7.50608 4.73586 7.4375L5.99961 4.00938L7.26336 7.4375C7.28837 7.50537 7.32781 7.567 7.37896 7.61815C7.43011 7.6693 7.49174 7.70874 7.55961 7.73375L10.9902 9L7.56211 10.2638ZM7.99961 2.5C7.99961 2.36739 8.05229 2.24021 8.14606 2.14645C8.23983 2.05268 8.367 2 8.49961 2H9.49961V1C9.49961 0.867392 9.55229 0.740215 9.64606 0.646447C9.73983 0.552678 9.867 0.5 9.99961 0.5C10.1322 0.5 10.2594 0.552678 10.3532 0.646447C10.4469 0.740215 10.4996 0.867392 10.4996 1V2H11.4996C11.6322 2 11.7594 2.05268 11.8532 2.14645C11.9469 2.24021 11.9996 2.36739 11.9996 2.5C11.9996 2.63261 11.9469 2.75979 11.8532 2.85355C11.7594 2.94732 11.6322 3 11.4996 3H10.4996V4C10.4996 4.13261 10.4469 4.25979 10.3532 4.35355C10.2594 4.44732 10.1322 4.5 9.99961 4.5C9.867 4.5 9.73983 4.44732 9.64606 4.35355C9.55229 4.25979 9.49961 4.13261 9.49961 4V3H8.49961C8.367 3 8.23983 2.94732 8.14606 2.85355C8.05229 2.75979 7.99961 2.63261 7.99961 2.5ZM14.4996 5.5C14.4996 5.63261 14.4469 5.75979 14.3532 5.85355C14.2594 5.94732 14.1322 6 13.9996 6H13.4996V6.5C13.4996 6.63261 13.4469 6.75979 13.3532 6.85355C13.2594 6.94732 13.1322 7 12.9996 7C12.867 7 12.7398 6.94732 12.6461 6.85355C12.5523 6.75979 12.4996 6.63261 12.4996 6.5V6H11.9996C11.867 6 11.7398 5.94732 11.6461 5.85355C11.5523 5.75979 11.4996 5.63261 11.4996 5.5C11.4996 5.36739 11.5523 5.24021 11.6461 5.14645C11.7398 5.05268 11.867 5 11.9996 5H12.4996V4.5C12.4996 4.36739 12.5523 4.24021 12.6461 4.14645C12.7398 4.05268 12.867 4 12.9996 4C13.1322 4 13.2594 4.05268 13.3532 4.14645C13.4469 4.24021 13.4996 4.36739 13.4996 4.5V5H13.9996C14.1322 5 14.2594 5.05268 14.3532 5.14645C14.4469 5.24021 14.4996 5.36739 14.4996 5.5Z"
            fill="#271900"
          />
        </svg>
        Novo!
      </span>

      <button class="btn favorite-btn">
        <i class="bi bi-star"></i>
      </button>
    </div>

    <!-- Corpo do cartão -->
    <div class="card-body border border-top-0 rounded-bottom-1 pb-md-0">
      <div class="d-flex align-items-center mb-2">
        <i [class]="icon" class="me-2 text-danger"></i>
        <div [innerHTML]="getSvg(icon)"></div>
        <div class="d-flex flex-wrap ms-3">
          <h6
            class="fs-6 ml-1 text-truncate col-12 col-sm-10 ps-0 col-md-12 ps-0 flex-grow col-lg-12 col-xl-12 text-wrap"
          >
            {{ title }}
          </h6>
          <div *ngFor="let contentType of contentTypes">
            <span
              class="badge text-truncate py-2 px-2 m-1 mx-1"
              [ngStyle]="{
                color: contentType.textcolor,
                'background-color': contentType.backgroundcolor
              }"
            >
              {{ contentType.name }}
            </span>
          </div>
          <div *ngFor="let module of modules">
            <span
              class="badge text-truncate m-1 py-2 px-2 mx-1"
              [ngStyle]="{
                color: module.textcolor,
                'background-color': module.backgroundcolor
              }"
            >
              {{ module.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</a>
